import React, { memo } from "react";

export default memo(({ canvasRef }) => {
  return <canvas width="400" height="400" ref={canvasRef}></canvas>;
});
